import { Article } from '~src/types/article'

const article: Article = {
  id: 6,
  date: 'Tue Aug 14 2025 16:05:47 GMT+0200 (Central European Summer Time)',
  title: 'Która stal jest najlepsza?',
  mainPicture: {
    type: 'img',
    src: 'Magna_wykres_02',
    description: 'Wykres najlepszych stali używanych w nożownictwie',
    width: '100%',
  },
  content: [
    {
      type: 'p',
      content: '',
    },
    {
      type: 'p',
      content:
        'Aspiracją ludzi, którzy z pasją zajmują się swoimi dziedzinami, jest dążenie do szeroko pojętej doskonałości – nie inaczej jest w przypadku twórców noży. Można jej szukać w geometrii, detalach, wyważeniu czy pięknie projektu… ale specyfika ostrzy sprawia, że prędzej czy później na pierwszy plan wysuwa się kwestia doboru odpowiedniej stali. Temat jest trudny, ale nie będziemy przed nim uciekać.',
    },
    {
      type: 'p',
      content:
        'Wieloletnie doświadczenia w rozmowach z klientami pokazują, że dyskusje o stalach i ich właściwościach często przypominają rzucanie grochem o ścianę pełną dobrych intencji. Niestety/Na szczęście - większość osób woli zaufać sprzedawcy, zamiast zagłębiać się w skomplikowane szczegóły. Ten artykuł jest jednak przeznaczony dla tych, którzy chcą zrobić krok dalej i zrozumieć dylematy związane z wyborem gatunków stali.',
    },
    {
      type: 'subtitle',
      content: 'Od czego zacząć?',
    },
    {
      type: 'p',
      content:
        'Wybór najlepszej stali wymaga odpowiedzi na pytanie : jakich cech oczekujemy od najlepszej stali? A jeszcze zanim to, warto zastanowić się - czym te wszystkie stale się od siebie w ogóle różnią?',
    },
    {
      type: 'p',
      content: 'Jedziemy po kolei…',
    },

    {
      type: 'p',
      content:
        'Noże kuchenne to specyficzne typy ostrzy, raczej delikatne, zwykle o bardzo cienkich przekrojach, a jednocześnie poddawane uderzeniom i ciągłemu tarciu o deski i krojone produkty. Żeby odpowiedzieć na takie wyzwania, stali nie możemy rozpatrywać pod kątem pojedynczej cechy (np. twardości), bo ważny będzie balans kilku cech. Żeby zrozumieć lepiej te zależności weźmy pod uwagę dwie najważniejsze z punktu widzenia żywotności krawędzi, czyli: odporność stali na ścieranie (zależna od typu i procentowej zawartości węglików w hartowanym materiale) oraz odporności na wykruszanie/łamanie - tzw. udarności.',
    },
    {
      type: 'p',
      content:
        'Do tego moglibyśmy dodać jeszcze twardość (HRC) i odporność na korozję, ale dla potrzeb tej części tekstu nie będziemy sprawy komplikować. Wrócimy do nich na koniec.',
    },
    {
      type: 'p',
      content:
        "Im większa odporność stali na ścieranie, tym krawędź wolniej tępi się przez tarcie (ale zwykle szybciej kruszy). A im większa udarność, tym mniejsza szansa, że krawędź wykruszy się np. przy trafieniu na piasek, kość, czy rant patelni (ale zwykle wtedy szybciej się ściera). Na wykresie oznacza to, że jeśli przesuniemy gatunek 'w górę' na jednej z osi, to zwykle spadnie on niżej na drugiej osi.",
    },
    {
      type: 'p',
      content:
        "Póki co nie udało się wyprodukować stali, w której obie te cechy spotkałyby się w najwyższych wartościach 'skali' (Unicorn Zone). Nawet najlepsze gatunki stali mają ten balans cech zachwiany na korzyść jednej, kosztem drugiej.",
    },
    {
      type: 'img',
      src: 'best_steel_article1',
      description: '',
      width: '100%',
    },
    {
      type: 'subtitle',
      content: 'Dobór do użytkownika',
    },
    {
      type: 'p',
      content:
        "Przy wytwarzaniu noży staramy się zaproponować najlepiej dopasowany materiał do stylu pracy i potrzeb danego użytkownika. Idąc tym tropem: dla osób, które mają poprawną technikę pracy i używa noża do lżejszych zadań polecimy stal o dominującej cesze odporności na ścieranie (np. M390 i inne stale 'z lewej' strony wykresu).",
    },
    {
      type: 'p',
      content:
        'A dla osób, którym może zdarzyć się nieuważny ruch albo praca w twardszych produktach, stale o większej udarności (np. AEB-L i prawa strona wykresu).',
    },
    {
      type: 'p',
      content:
        'Obie grupy stali są znane i cenione przez rzesze kucharzy na całym świecie. Niektórzy z nich są zwolennikami większej udarności, inni z kolei odporności na ścieranie. Obie strony mają rację. :)',
    },
    {
      type: 'subtitle',
      content: 'Stale konwencjonalne i proszkowe',
    },
    {
      type: 'p',
      content:
        'Skoro wiemy już jakich cech szukamy w naszym idealnym materiale, to możemy się zastanowić jak je uzyskać. To rozważanie prowadzi nas prosto do składów stopowych i metod produkcji. Proste stale węglowe, składają się w głównej mierze z żelaza i węgla (ok 0,5 -1%), takie stale możemy znaleźć w dolnym narożniku naszego wykresu (poniżej O1) i z takich mniej więcej stali produkowano narzędzia przez setki lat. Niemniej, współcześnie do stali dodaje się też inne pierwiastki, które poprawiają jej poszczególne cechy np. Chrom, odpowiedzialny za nierdzewność i będący pierwiastkiem węglikotwórczym albo Wanad,czy Niob - podnoszące odporność na ścieranie. Jest ich dużo więcej (warto rzucić okiem na skład dowolnej stali stopowej). Można by pomyśleć, że im więcej pierwiastków wrzucimy do stopu, tym lepszy uzyskamy materiał. Ale to pułapka…',
    },
    {
      type: 'p',
      content:
        "Aby stal osiągała 'ponadstandardowe' parametry, często dodaje się do jej składu nawet ok 30% dodatków stopowych. To prowadzi do trudności technologicznych na etapie obróbki plastycznej i cieplnej po wytopie (kontrola rozmiaru węglików i ziarna). Konwencjonalne metody wytopu mają więc pewną technologiczną granicę możliwości, która jest trudna do pokonania.",
    },
    {
      type: 'p',
      content:
        "Powyżej granicy możliwości stali konwencjonalnych mamy tzw. 'Super-steels' ( przerywana granica na wykresie) - czyste, wysokostopowe stale o rewelacyjnych właściwościach. Te 'super' cechy uzyskuje się najczęściej w tzw. technologii proszków (PM alb RSP), która pozwala na zwiększenie ilości dodatków stopowych w składzie stali bez wystąpienia problemów, które ograniczają stale konwencjonalne. Takimi właśnie Supersteels są m.in. MagnaCut, M390 czy K390 - gatunek używany w naszych laminatach SanMaiKŁOSY. Narzędziowe stale proszkowe stanowią w tej chwili grupę najdoskonalszych materiałów wykorzystywanych do wyrobu ostrzy.",
    },
    {
      type: 'p',
      content: 'Technologia wytopu proszkowego ma dwie podstawowe zalety:',
    },
    {
      type: 'p',
      content:
        'pozwala na użycie dużej ilości dodatków węglikotwórczych - co podnosi odporność na materiału na ścieranie.',
    },
    {
      type: 'p',
      content:
        'pozwala uzyskać bardzo drobne ziarno i małej skali, równo rozłożone, węgliki - co podnosi udarność.',
    },
    {
      type: 'p',
      content:
        'Brzmi świetnie – i takie jest. Jedynym minusem jest cena. Technologia produkcji stali proszkowych jest wieloetapowa i dużo bardziej wymagająca niż tradycyjne metody wytopu, w związku z tym stale tego typu są trudniej dostępne i znacznie droższe - nawet kilkukrotnie - od gatunków konwencjonalnych.',
    },
    {
      type: 'p',
      content:
        "Jeśli jednak patrzymy na sprawę bezkompromisowo i nie zważamy na koszty, należałoby zwrócić się właśnie ku tym 'proszkowym' gatunkom w poszukiwaniu najlepszej stali na ostrza.",
    },
    {
      type: 'img',
      src: 'best_steel_article2',
      description: '',
      width: '100%',
    },
    {
      type: 'subtitle',
      content: 'Dlaczego nie zajmujemy się twardością',
    },
    {
      type: 'p',
      content:
        'Na wykresach celowo pomijamy twardość poszczególnych gatunków. Dlaczego? Bo wbrew powszechnemu przekonaniu, we współczesnych stalach, twardość nie ma szczególnego wpływu na żywotność krawędzi noża. Często jest wykorzystywana w marketingu jako intuicyjny wskaźnik - „im twardsze, tym lepsze", co nie jest prawdą i wprowadza klientów w błąd.',
    },
    {
      type: 'p',
      content:
        'Dane z testów pokazują, że nie istnieje prosta zależność między twardością a trzymaniem ostrości czy udarnością. Przykład: popularna w Europie nierdzewna stal N690 przy 59 HRC w statycznych testach trzymania ostrości(CATRA) kroi dwa razy dłużej niż np. stal BlueSuper - ceniona Japońska stal narzędziowa, przy twardości 65 HRC. W tym wypadku decydujące są pozostałe ich cechy(zawartość % i wielkość węglików), a same twardości mogą być mylące.',
    },
    {
      type: 'p',
      content:
        'Podsumowując, twardość zaczyna mieć znaczenie kiedy mówimy o tym samym gatunku ale hartowanym na różne poziomy. Występuje wtedy prosta korelacja : niższa twardość = szybsze ścieranie, ale większa udarność; wyższa twardość = wolniejsze ścieranie, ale większa kruchość.',
    },
    {
      type: 'p',
      content:
        "W przypadku każdego gatunku stali proces obróbki cieplnej przeprowadza się tak, żeby jak najlepiej wykorzystać możliwości danego stopu. Także możemy założyć, że porównywanie jakości noży wykonanych z różnych gatunków stali, na podstawie samej liczby 'HRC' jest wątpliwe etycznie i bezcelowe poznawczo.",
    },
    {
      type: 'subtitle',
      content: 'Jakość krawędzi a nierdzewność',
    },
    {
      type: 'p',
      content:
        'Przyzwyczailiśmy się myśleć, że dobre stale to stale nierdzewne, a wszystko, co rdzewieje, jest złej jakości. Tymczasem odporność na korozję nie ma większego wpływu na żywotność krawędzi noża kuchennego. Zanim ostrze stępi się od korozji, znacznie wcześniej ulegnie starciu albo wykruszeniu.',
    },
    {
      type: 'p',
      content:
        'Preferencja dla stali nierdzewnych wynika więc raczej z przyzwyczajenia i estetyki (błyszczące narzędzia), a także z wymogów higienicznych i certyfikacyjnych - gdzie nierdzewność traktowana jest jako standard.',
    },
    {
      type: 'p',
      content:
        'Niemniej, podczas poszukiwań najlepszych gatunków nożowniczych, ograniczenie naszych zainteresowań wyłącznie do stali nierdzewnych pozbawia nas dostępu do całej rodziny wspaniałych gatunków, które często mogą zaoferować znacznie lepszej jakości krawędzi niż jakiekolwiek stale nierdzewne.',
    },
    {
      type: 'p',
      content:
        'Nierdzewność w stalach narzędziowych uzyskuje się głównie przez dodanie dużej ilości chromu (13 - 14% i więcej). Niestety, wysoka zawartość chromu pogarsza inne cechy. Najtwardsze i najbardziej pożądane węgliki w stalach tworzą wanad, niob i wolfram (86 - 87 HRC). Węgliki chromu są znacznie miększe (72 - 76 HRC). Duże dodatki chromu z kolei „kradną" węgiel, który mógłby tworzyć twardsze związki z innymi pierwiastkami.',
    },
    {
      type: 'p',
      content:
        'Pewien zarys tego zjawiska można zobaczyć na wykresie, na którym stale nierdzewne oznaczone są na niebiesko a rdzewiejące na czarno. Widać, że całkiem sporo gatunków o bardzo dobrze zbalansowanych cechach (środek wykresu) nie jest nierdzewne.',
    },
    {
      type: 'p',
      content:
        "Takie stale często używane są na rdzenie laminatów i łączone z nierdzewnymi 'bokami' (np. SanMai KŁOSY). Właśnie te 'nie-nierdzewne' proszkowe stale narzędziowe są najlepszym co może znaleźć się na krawędzi tnącej noża (np. K390 / 10V / Vanadis 8 ).",
    },
    {
      type: 'subtitle',
      content: 'Nowe kierunki',
    },
    {
      type: 'p',
      content:
        'W ostatnich latach na rynku pojawiło się kilka nowych gatunków, projektowanych specjalnie pod kątem cech wartościowych przy produkcji ostrzy (ApexUltra(dla kowali), M390(98), MagnaCut). Każdorazowo oferują one stopniową poprawę poszczególnych cech.',
    },
    {
      type: 'p',
      content:
        'Równolegle trwają prace nad stalami z dodatkiem niobu i azotu (kosztem węgla), które mogą otworzyć drogę do jeszcze lepszych parametrów.',
    },
    {
      type: 'p',
      content:
        'Interesującym kierunkiem są też stale macierzowe (MATRIX), opracowywane przez Böhler/Uddeholm. Ich idea polega na utrzymywaniu dodatków stopowych w roztworze zamiast wiązania ich w węgliki – podobnie jak w stalach szybkotnących. Dzięki temu uzyskują one bardzo wysokie twardości i jednocześnie świetną udarność, bez konieczności stosowania technologii proszkowej, co obniża cenę materiału.',
    },
    {
      type: 'img',
      src: 'best_steel_article3',
      description: '',
      width: '100%',
    },
    {
      type: 'subtitle',
      content: 'Podsumowanie',
    },
    {
      type: 'p',
      content:
        'Wracając do odpowiedzi na pytanie z początku artykułu - czym te stale się od siebie różnią - mam nadzieję, że możemy - już z pewną znajomością tematu - odpowiedzieć, że WSZYSTKIM. Stale są fascynujące i im dalej zagłębiać się w ich świat, tym więcej znajduje się do odkrycia.',
    },
    {
      type: 'p',
      content:
        'Niby nie trzeba tego wszystkiego wiedzieć, żeby czerpać przyjemność z krojenia świetnym nożem - niemniej, świadomość tego z jak pięknych, złożonych materiałów korzystamy krojąc cebulę, oraz ile lat rozwoju ludzkiej myśli technicznej, pracy i kreatywności inżynierów złożyło się na ich powstanie, może dać nam poczucie pewnej dumy i wiary w nasz kruchy, błądzący gatunek.',
    },
    {
      type: 'p',
      content:
        'Artykuł obiecywał odpowiedź na pytanie \'która stal jest najlepsza" - poniżej nasze subiektywne, ale aspirujące do powszechności, wnioski na rok 2025.',
    },
    {
      type: 'list',
      items: [
        'jeśli nie przeszkadza Ci korozja - K390(SanMaiKŁOSY) / Vanadis 8 / 10V',
        'jeśli musi być nierdzewne i zbalansowane - MagnaCut / Vanax',
        'jeśli musi być nierdzewne i obiecasz uważać co robisz - M390 / S110V / Elmax',
        'jeśli musi być nierdzewne i obiecasz bardzo uważać co robisz - M398',
      ],
    },
    {
      type: 'p',
      content:
        'Wydaje się, że jeszcze nieraz będziemy musieli aktualizować wnioski w tym artykule, goniąc nowe osiągnięcia producentów stali. Niemniej warto docenić już obecne materiały, które oferują kosmiczne wręcz możliwości i niedostępną nigdy w historii jakość krawędzi tnących.',
    },
  ],
  en: {
    id: 6,
    date: 'Tue Aug 14 2025 16:05:47 GMT+0200 (Central European Summer Time)',
    title:
      'Which steel is the best? - more than you ever wanted to know about modern tool-steel grades.',
    mainPicture: {
      type: 'img',
      src: 'Magna_wykres_02',
      description: 'Best knife steel grades Chart',
      width: '100%',
    },
    content: [
      {
        type: 'p',
        content: '',
      },
      {
        type: 'p',
        content:
          "For anyone deeply passionate about their craft, the natural aspiration is the pursuit of excellence - and knife makers are no exception. Excellence can be sought in geometry, details, balance, or the elegance of design… but the very nature of blades means that sooner or later, the question of steel choice comes to the forefront. It's not an easy subject, but let's not dodge it.",
      },
      {
        type: 'p',
        content:
          'Years of conversations with customers have shown us that discussions about steel and its properties often resemble talking to a wall full of good intentions. Unfortunately - or maybe fortunately - most people prefer to trust the seller rather than dive into the complexities. This article, however, is written for those who want to take a step further towards understanding of the dilemmas involved in choosing proper steel grades.',
      },
      {
        type: 'subtitle',
        content: 'Where do we begin?',
      },
      {
        type: 'p',
        content:
          'Choosing the best steel requires answering some pre-questions: what do we actually expect from the best steel? And even before that - how do all these steels even differ from one another?',
      },
      {
        type: 'p',
        content: "Let's go step by step…",
      },
      {
        type: 'p',
        content:
          "Kitchen knives are a special type of blades: relatively fragile, usually ground very thin, yet subjected to repeated impact and constant friction against cutting boards and food. To meet these challenges, blade-steels cannot be judged by a single property (like for ex. hardness). What matters is the balance of several. To better understand this balance, let's look at the two most important factors for edge longevity: wear resistance (depending on carbide type and percentage in the hardened steel) and toughness (the ability to resist chipping and breaking).",
      },
      {
        type: 'p',
        content:
          "We could also add hardness (HRC) and corrosion resistance to the mix, but for now let's keep things simple—we'll return to those later.",
      },
      {
        type: 'p',
        content:
          'The higher the wear resistance, the slower the edge dulls from friction (but the faster it tends to chip). The higher the toughness, the less likely the edge will chip on contact with sand particles, bones or a pan edge (but the faster it tends to dull). On a graph, shifting a steel grade along one axis usually means it drops on the other.',
      },
      {
        type: 'p',
        content:
          'So far, no steel has been created where both properties reach maximum values (the Unicorn Zone). Even the best steels lean one way or the other.',
      },
      {
        type: 'img',
        src: 'best_steel_article1',
        description: '',
        width: '100%',
      },
      {
        type: 'subtitle',
        content: 'Matching steel to the user',
      },
      {
        type: 'p',
        content:
          "When making knives, we try to choose the material best suited to each person's style and needs. Following this logic:",
      },
      {
        type: 'p',
        content:
          '– For those with good technique who use knives for lighter tasks, we recommend steels that excel in wear resistance (e.g. M390 and others from the "left side" of the graph).',
      },
      {
        type: 'p',
        content:
          '– For those prone to careless moves or working with tougher foods, we suggest steels with higher toughness (e.g. AEB-L and the "right side" of the graph).',
      },
      {
        type: 'p',
        content:
          'Both groups of steels are well-known and loved by chefs worldwide. Some swear by toughness, others by wear resistance. Both sides are right. :)',
      },
      {
        type: 'subtitle',
        content: 'Conventional vs. powder steels',
      },
      {
        type: 'p',
        content:
          "Now that we know what traits we're after, how do we get them? That brings us to alloy composition and production methods. Simple carbon steels consist mostly of iron and carbon (about 0.5–1%). These sit in the lower corner of our graph (below O1) and have been used for centuries. Nowadays, however, additional elements are introduced to enhance specific traits - chromium for corrosion resistance and carbide formation, vanadium and niobium for wear resistance, and many more (take a glance at any alloy steel composition chart). One might think that the more elements we throw in, the better the steel - but that's a trap.",
      },
      {
        type: 'p',
        content:
          'To reach above-standard properties, steels often contain even up to 30% alloying elements. This creates processing difficulties during melts, rolling and heat treatment (controlling carbide size and grain structure). Conventional melting has technological limits that are hard to surpass.',
      },
      {
        type: 'p',
        content:
          'Beyond those limits lie the so-called "Super Steels" (dashed line on the graph): ultra-clean, high-alloy steels with outstanding properties. These are most often produced using powder metallurgy (PM or RSP-RapidSolidifiedPowder), which allows high alloy content without the problems of conventional steels. Examples include MagnaCut, M390, and K390 - the latter used in our SanMaiKŁOSY laminates. Powder tool steels are currently the pinnacle of blade materials.',
      },
      {
        type: 'p',
        content: 'Powder metallurgy has two key advantages:',
      },
      {
        type: 'p',
        content:
          '- It allows for high amounts of carbide-forming elements, boosting wear resistance.',
      },
      {
        type: 'p',
        content:
          '- It produces very fine, evenly distributed carbides, improving toughness.',
      },
      {
        type: 'p',
        content:
          "Sounds great - and it is. The only drawback is cost. Powder steels are highly demanding to produce, which makes them much more expensive and less accessible - often several times pricier than conventional grades. But if you want the best, and budget isn't a concern, powder steels are the way to go.",
      },
      {
        type: 'img',
        src: 'best_steel_article2',
        description: '',
        width: '100%',
      },
      {
        type: 'subtitle',
        content: "Why we're not talking about hardness",
      },
      {
        type: 'p',
        content:
          'On our graphs we deliberately omit hardness values. Why? Because contrary to popular belief, hardness does not directly determine edge life in modern steels. It\'s often used as a simple marketing hook - "the harder, the better" - but that\'s misleading.',
      },
      {
        type: 'p',
        content:
          'Test data show no straightforward correlation between hardness and edge retention or toughness when comparing different steel grades. Example: the popular stainless steel N690 at 59 HRC can last twice as long in CATRA edge retention tests as Blue Super - a respected Japanese tool steel - at 65 HRC. In this case, carbide content matters far more than the raw Rockwell number.',
      },
      {
        type: 'p',
        content:
          'Hardness only really matters when comparing the same steel grade at different heat-treatment levels. Then the correlation is simple: lower hardness = faster wear but higher toughness; higher hardness = slower wear but greater brittleness.',
      },
      {
        type: 'p',
        content:
          "For every steel, the heat treatment is tuned to maximize its potential. That's why comparing knives solely by their HRC rating is not just meaningless but borderline unethical.",
      },
      {
        type: 'subtitle',
        content: 'Edge quality vs. corrosion resistance',
      },
      {
        type: 'p',
        content:
          'We\'ve gotten used to thinking that "good steel" must mean stainless, and anything that rusts is of low quality. In reality, corrosion resistance has little to do with edge life. A knife will dull from wear or chipping long before corrosion plays a considerable role.',
      },
      {
        type: 'p',
        content:
          'Preference for stainless steels plays a major role at hygiene and certification standards which is important in professional gastronomy but in everyday life it narrows mainly to aesthetics - people like shiny blades.',
      },
      {
        type: 'p',
        content:
          'Unfortunately if we were to limit ourselves only to stainless, we cut off access to an entire family of steels that often outperform any stainless in edge quality.',
      },
      {
        type: 'p',
        content:
          'Corrosion resistance in tool steels mainly comes from high chromium content (13–14% or more). But a lot of chromium has downsides. The hardest and most desirable carbides come from vanadium, niobium, and tungsten (86–87 HRC). Chromium carbides are much softer (72–76 HRC). The main problem is that this excess chromium "steals" carbon that could otherwise form harder carbides with other elements.',
      },
      {
        type: 'p',
        content:
          'You can see this tradeoff on the graph, where stainless steels are marked in blue and non-stainless in black. Many well-balanced grades (middle of the graph) are not stainless.',
      },
      {
        type: 'p',
        content:
          'These steels are often used as the core in laminated blades, clad with stainless outer layers (e.g. SanMai KŁOSY). Non-stainless cold-work powder tool steels are, in fact, some of the best edge materials you can find (e.g. K390, 10V, Vanadis 8).',
      },
      {
        type: 'subtitle',
        content: 'New directions',
      },
      {
        type: 'p',
        content:
          'In recent years, several new grades have emerged, designed specifically with blade properties in mind (ApexUltra for bladesmiths, M390(98), MagnaCut). Each offering incremental improvements.',
      },
      {
        type: 'p',
        content:
          'There is also ongoing research into steels alloyed with niobium and nitrogen (at the expense of carbon), which may unlock even better performance.',
      },
      {
        type: 'p',
        content:
          'Another promising path is the "matrix steels" developed by Böhler/Uddeholm. The idea is to keep alloying elements dissolved in the solution/matrix rather than forming larger carbides - in a similar way the high-speed steels work. This allows achieving very high hardness and excellent toughness without using powder metallurgy and therefore reducing costs.',
      },
      {
        type: 'img',
        src: 'best_steel_article3',
        description: '',
        width: '100%',
      },
      {
        type: 'subtitle',
        content: 'Conclusion',
      },
      {
        type: 'p',
        content:
          'Returning to the initial question - how do steels differ from one another? Hopefully now we can confidently say: in every possible way. Steels are fascinating, and the deeper you go, the more there is to discover.',
      },
      {
        type: 'p',
        content:
          "Fortunately, you don't need to know all this to enjoy slicing with a great knife - but on the other hand realizing that every onion you chop rests on decades of technical innovation, human ingenuity, and creative engineering can give you a little sense of pride, and maybe a touch of faith in our fragile, fumbling species.",
      },
      {
        type: 'p',
        content:
          'The article promised an answer to "Which steel is the best?" - so here are our subjective, but 2025-relevant, conclusions:',
      },
      {
        type: 'list',
        items: [
          "If you don't mind rust: K390 (SanMaiKŁOSY) / Vanadis 8 / 10V",
          'If it must be stainless and balanced: MagnaCut / Vanax',
          'If it must be stainless and you promise to be careful: M390 / S110V / Elmax',
          'If it must be stainless and you promise to be very careful: M398',
        ],
      },
      {
        type: 'p',
        content:
          "It seems clear that we'll need to keep updating these conclusions as steelmakers bring new innovations to market. But even today's steels already offer quasi sci-fi performance and a cutting-edge quality never seen before.",
      },
    ],
  },
}

export default article
